import request from '@/utils/request'

/*
 * 授课老师应读明细查询
 */
export function findShouldTeacherList(params) {
    return request({
        url: `/system/recite-report/reciteEductionList/query`,
        method: 'post',
        data: params
    })
}

/*
 * 销售运营应读明细查询
 */
export function findShouldSaleList(params) {
    return request({
        url: `/system/recite-report/reciteSaleList/query`,
        method: 'post',
        data: params
    })
}

/*
 * 授课老师晨读明细查询
 */
export function findRealTeacherList(params) {
    return request({
        url: `/system/recite-report/reciteEductionbyPage/query`,
        method: 'post',
        data: params
    })
}

/*
 * 销售运营晨读明细查询
 */
export function findRealSaleList(params) {
    return request({
        url: `/system/recite-report/reciteSalebyPage/query`,
        method: 'post',
        data: params
    })
}

/*
 * 员工查询，传入用户输入的文本即可，后端已做处理：工号还是名字
 *
 * queryRole 是否查询角色，传"1"查询
 */
export function findStaffQuery(query, userId, status, queryRole = undefined, pageSize = 999, pageNum = 1) {
    return request({
        url: `/system/search-comm/user`,
        method: 'post',
        headers: { repeatSubmit: false },
        data: {
            data: {
                content: query,
                userId,
                status,
                queryRole,
            },
            pageSize,
            pageNum,
        }
    })
}
